import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { EntityList } from '../shared';
import { 
  useNeedsData, 
  useNeedsFilters,
  useNeedsTableConfig, 
} from './hooks';

const Needs: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState<string>('');

  // Custom hooks for data and filtering
  const { data } = useNeedsData();
  const columns = useNeedsTableConfig();
  const { 
    setAppliedFilters, 
    filterDefinitions, 
    filteredData,
  } = useNeedsFilters(data, searchQuery);

  // Handlers
  const handleCreateNeedsList = useCallback(() => {
    console.log('Create needs list');
  }, []);

  const handleDownloadCSV = useCallback(() => {
    console.log('Download CSV');
  }, []);

  const handlePrint = useCallback(() => {
    console.log('Print');
  }, []);

  const handleRowClick = useCallback((needsList: any) => {
    navigate(`/needs/detail/${needsList.id}`);
  }, [navigate]);

  return (
    <EntityList
      // Page configuration
      objectTitle="Needs"
      
      // Primary action
      primaryAction={{
        label: 'Create Needs List',
        icon: LucideIcons.Plus,
        onClick: handleCreateNeedsList
      }}
      
      // Search
      searchPlaceholder="Search by name, coordinator, group, or item..."
      onSearchChange={setSearchQuery}
      
      // Table configuration
      columns={columns}
      getRowKey={(needsList) => needsList.id}
      emptyMessage="No needs lists found"
      pageSize={10}
      onRowClick={handleRowClick}
      
      // Data
      filteredData={filteredData}
      
      // Filters
      filterDefinitions={filterDefinitions}
      onApplyFilters={setAppliedFilters}
      
      // Default actions
      onDownloadCSV={handleDownloadCSV}
      onPrint={handlePrint}
    />
  );
};

export default Needs;
